module.exports = __webpack_public_path__ + "img/166.8f995b60.jpg";